import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import NotificationRowContent from 'components/notifications/NotificationRowContent';

function PlanAcquisitionRequestedNotification({ notification }) {
  const { t } = useTranslation(['notifications']);
  const { client, plan } = notification.data;

  return (
    <NotificationRowContent
      notification={notification}
      user={client}
      title={client.full_name}
      body={t('planRequest.acquisition.body', {
        name: plan.name,
        ns: 'notifications',
        defaultValue: `Solicitó el plan ${plan.name}`
      })}
    />
  );
}

PlanAcquisitionRequestedNotification.propTypes = {
  notification: PropTypes.shape({
    created_at: PropTypes.string.isRequired,
    data: PropTypes.shape({
      client: PropTypes.shape({
        full_name: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
        photo: PropTypes.string
      }).isRequired,
      plan: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    id: PropTypes.string.isRequired,
    read: PropTypes.bool.isRequired
  }).isRequired
};

export default PlanAcquisitionRequestedNotification;
